import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';

const STAT_DEFS = [
  { key: 'pending', label: 'Pending', color: 'text-slate-700 dark:text-slate-300' },
  { key: 'acknowledged', label: 'Acknowledged', color: 'text-blue-600' },
  { key: 'deducted', label: 'Deducted', color: 'text-emerald-600' },
  { key: 'waived', label: 'Waived', color: 'text-purple-600' },
];

const fmt = (n) => new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(n || 0);

export default function PenaltyStats({ stats }) {
  const byStatus = (stats && stats.by_status) || {};
  const repeat = (stats && stats.repeat_offenders) || [];

  return (
    <>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {STAT_DEFS.map(function(def) {
          const s = byStatus[def.key] || { count: 0, amount: 0 };
          return (
            <Card key={def.key} data-testid={'penalty-stat-' + def.key}>
              <CardContent className="pt-4 pb-3">
                <p className="text-xs text-muted-foreground uppercase tracking-wide">{def.label}</p>
                <p className={'text-2xl font-bold mt-1 ' + def.color}>{s.count}</p>
                <p className="text-xs text-muted-foreground font-mono">{fmt(s.amount)}</p>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {repeat.length > 0 && (
        <Card className="border-rose-200 dark:border-rose-900" data-testid="repeat-offenders-card">
          <CardContent className="pt-4 pb-3">
            <p className="text-xs font-semibold text-rose-600 flex items-center gap-1.5 mb-2">
              <AlertTriangle className="h-3.5 w-3.5" />REPEAT SHORTCOMINGS
            </p>
            <div className="flex flex-wrap gap-2">
              {repeat.map(function(r) {
                return (
                  <div key={r._id} className="text-xs bg-rose-50 dark:bg-rose-950 border border-rose-200 dark:border-rose-900 rounded-full px-3 py-1">
                    <span className="font-medium">{r.name || r._id}</span>
                    <span className="text-rose-600 ml-1.5 font-semibold">{r.count}×</span>
                    <span className="text-muted-foreground ml-1.5 font-mono">{fmt(r.amount)}</span>
                  </div>
                );
              })}
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
}
